// extracted by css-extract-rspack-plugin
export default {"marker":"ze1fkZ59SvwfmDdN"};